import { createApp } from 'vue';
import { datadogRum } from '@datadog/browser-rum';
import App from './App.vue';
import { router, registerModuleRoutes } from './router';
import { initializePinia } from './stores/store';
import { implementsMiddlewareOnRouter } from './middlewares';
import i18n from './language';

const app = createApp(App);
app.use(i18n);

const isProduction = import.meta.env.VITE_ADMIN_DD_ENVIRONMENT === 'production';

if (isProduction) {
  datadogRum.init({
    applicationId: import.meta.env.VITE_ADMIN_DD_APPLICATIONID,
    clientToken: import.meta.env.VITE_ADMIN_DD_CLIENTTOKEN,
    site: 'datadoghq.com',
    service: import.meta.env.VITE_ADMIN_DD_SERVICE,
    env: import.meta.env.VITE_ADMIN_DD_ENVIRONMENT,
    version: import.meta.env.PACKAGE_VERSION,
    defaultPrivacyLevel: 'mask-user-input',
    sessionSampleRate: 10,
    sessionReplaySampleRate: 10,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
  });
}

async function registerModules() {
  const modules = [import('admin/App'), import('login/App'), import('whatsappFlows/App')];

  for await (const module of modules) {
    registerModuleRoutes(module.default(app), module.parentName || 'home');
  }

  await implementsMiddlewareOnRouter(router);
}

registerModules().then(() => {
  app.use(router);
  app.use(initializePinia());
  app.mount('#app');
  const loader = document.getElementById('loader-container');

  if (loader) {
    setTimeout(() => {
      loader.remove();
    }, 500);
  }
});
